<template>
  <div>
    <view-banners></view-banners>
    <section class="section-container-title container-fluid section text-white" style="padding-bottom:0px !important">
      <div class="row">
        <div class="col-md-12 col-lg-12 order-1 mb-5 mb-md-0 ">
          <view-noticias></view-noticias>
        </div>
        <!-- <div class="col-md-4 col-lg-3 order-2 bg-light-2">
          <view-tweets></view-tweets>
        </div> -->
      </div>
    </section>
    <section class="section-container-title container-fluid section text-white">
      <div class="row">
        <div class="col-md-12 ">
          <view-voluntariado></view-voluntariado>
        </div>
      </div>
    </section>
    <!-- <script type="application/javascript" src="assets/vendor/bootstrap/js/popper.js"></script>
    <script type="application/javascript" src="assets/js/other.js"></script>
    <script type="application/javascript" src="assets/js/page.js"></script> -->
  </div>
</template>

<script>
import Swal from "sweetalert2";

import viewBanners from "@/components/home/view-banners";
import viewNoticias from "@/components/home/view-noticias";
import viewTweets from "@/components/home/view-tweets";
import viewVoluntariado from "@/components/home/view-voluntariado";

export default {
  name: "view-home",
  metaInfo: { title: "Transparencia Perú" },

  components: {
    viewBanners,
    viewNoticias,
    viewTweets,
    viewVoluntariado,
  },
  data: () => ({
    // Sin datos del backend
    urlPopup: ''
  }),
  methods: {
    loadPopup() {
      Swal.fire({
        showConfirmButton: false,
        showCloseButton: false, // 👈 desactivamos el close nativo
        padding: 0,
        background: "transparent",
        width: "auto",

        html: `
    <div class="swal-custom-wrapper">
      
      <!-- BOTÓN CLOSE INTERNO -->
      <button class="swal-btn-close" aria-label="Cerrar">
        ✕
      </button>

      <img
        src="${this.urlPopup}"
        alt="Inscripción de Voluntariado"
        class="swal-img-clickable"
      />
    </div>
  `,

        didOpen: () => {
          // cerrar modal
          document
            .querySelector(".swal-btn-close")
            .addEventListener("click", () => Swal.close());

          // click en imagen
          document
            .querySelector(".swal-img-clickable")
            .addEventListener("click", () => {
              window.open(
                "https://www.transparencia.org.pe/observa",
                "self"
              );
              Swal.close();
            });
        }
      });

    },
  },

  mounted() {
    this.urlPopup = this.fileWebUrl("assets/images/img_popup_registro_formulario.jpeg");
    this.loadPopup();
  },
};
</script>
<style>
.swal-custom-wrapper {
  position: relative;
  line-height: 0;
}

.swal-img-clickable {
  display: block;
  width: 100%;
  max-width: 520px;
  border-radius: 12px;
  cursor: pointer;
}

/* BOTÓN CLOSE */
.swal-btn-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
}

.swal-btn-close:hover {
  background: rgba(0, 0, 0, 0.8);
}
</style>